<template>
  <div class="container">
    <div class="download-wrapper">
      <h2>赛事通知、模版下载</h2>

      <!-- 数据表格 -->
      <el-table
        :data="filteredTableData"
        style="width: 100%"
        stripe
        border
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="name" label="模板名称"> </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="downloadFile(scope.row)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      searchText: "", // 搜索框内容
      loading: false, // 表格加载状态
      allTemplates: [], // 存储所有模板数据
    };
  },
  computed: {
    // 计算属性：根据搜索框内容过滤表格数据
    filteredTableData() {
      if (!this.searchText) {
        return this.allTemplates;
      }
      return this.allTemplates.filter((item) =>
        item.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
  },
  created() {
    // 初始化页面数据
    this.allTemplates = [
      {
        id: 1,
        name: "第四届校园气象观测和应用挑战赛的通知",
        url: "https://kxwj.cn/observer/files/比赛活动通知.pdf",
      },
      {
        id: 2,
        name: "附件1:活动申报表模版",
        url: "https://kxwj.cn/observer/files/附件1. 活动申报表（第四届校园气象观测和应用挑战赛）.docx",
      },
      {
        id: 3,
        name: "附件2:气象观测记录表",
        url: "https://kxwj.cn/observer/files/附件2. 气象观测记录表.docx",
      },
      {
        id: 4,
        name: "报告或小论文格式模板",
        url: "https://kxwj.cn/observer/files/附件3. 报告或小论文格式模板.docx",
      },
    ];
  },
  methods: {
    // 下载文件方法
    async downloadFile(row) {
      this.loading = true; // 开始下载时显示加载中
      this.$message.info("文件下载中，请稍候...");
      try {
        saveAs(row.url, row.name);
        this.$message.success("文件下载成功！");
      } catch (error) {
        console.error("下载文件失败:", error);
        this.$message.error("文件下载失败，请稍后重试。");
      } finally {
        this.loading = false; // 结束下载时移除加载中
      }
    },
  },
};
</script>

<style scoped lang="less">
.container {
  padding: 40px;
  background-color: #f5f7fa; /* 页面背景色，使其看起来更干净 */
  min-height: 100vh;
}
.download-wrapper {
  width: 1000px; /* 匹配你之前页面的宽度 */
  margin: 20px auto; /* 调整外边距，使其不要太靠上 */
  padding: 30px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
h2 {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 25px; /* 标题和搜索框的间距 */
  text-align: left; /* 标题居左 */
}
/deep/.el-table {
  margin-top: 20px;
  font-size: 24px;
  color: #333;
}
.el-table-column .el-button {
  font-weight: bold;
}
</style>

